import { render, staticRenderFns } from "./GoService.vue?vue&type=template&id=f74acbb2&scoped=true&"
import script from "./GoService.vue?vue&type=script&lang=js&"
export * from "./GoService.vue?vue&type=script&lang=js&"
import style0 from "./GoService.vue?vue&type=style&index=0&id=f74acbb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74acbb2",
  null
  
)

export default component.exports